import Promise from 'bluebird';
import $ from 'jquery';
import _ from 'underscore';

export class AjaxError extends Error {
  constructor(xhr, textStatus, errorThrown) {
    super(errorThrown);
    this.name = 'AjaxError';
    this.xhr = xhr;
    this.textStatus = textStatus;
    this.errorThrown = errorThrown;
  }
}

export class JsonError extends Error {
  constructor(data, status, xhr) {
    super();
    this.name = 'JsonError';
    this.data = data;
    this.status = status;
    this.xhr = xhr;
  }
}

function generateSuccessAndFail(options, resolve, reject) {
  const prevOnSuccess = $.isFunction(options.onSuccess) ? options.onSuccess : _.noop;
  const prevOnAjaxError = $.isFunction(options.onAjaxError) ? options.onAjaxError : _.noop;

  return _.extend(options, {
    onSuccess: (data, status, inputData, onSuccessEventData, xhr) => {
      prevOnSuccess(data, status, inputData, onSuccessEventData, xhr);
      $.advertiser.ajaxSuccess(
        data,
        status,
        xhr,
        () => resolve(data),
        () => reject(new JsonError(data, status, xhr)),
        options.redirectHandler
      );
    },
    onAjaxError: (xhr, textStatus, errorThrown) => {
      prevOnAjaxError(xhr, textStatus, errorThrown);
      reject(new AjaxError(xhr, textStatus, errorThrown));
    },
  });
}

function createPromise(requestFunction, options) {
  return new Promise((resolve, reject) => {
    requestFunction(generateSuccessAndFail(options, resolve, reject));
  });
}

export function post(options) {
  return createPromise($.advertiser.ajaxPost, options);
}

export function get(options) {
  return createPromise($.advertiser.ajaxGet, options);
}

export function patch(options) {
  return createPromise($.advertiser.ajaxPatch, options);
}
